import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { StorageMonitorService } from './storageMonitorService.service';
import { LogoutService } from './logout.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private tokenExpirationTimer: any;
  private inactivityTimer: any;
  private checkInterval: any;
  userEmail: any;

  constructor(
    private http: HttpClient,
    private storageMonitorService: StorageMonitorService,
    private logoutService: LogoutService
  ) {
    this.startMonitoring();
  }
  urlApiManagement = environment.urlApiManagement;

  login(userEmail: any) {
    const url = `${this.urlApiManagement}/api/v1/token/login`;
    const body = {
      userEmail: userEmail
    };
    this.userEmail = userEmail;
    this.http.post(url, body).subscribe({
      next: (response: any) => {
        localStorage.setItem('mlct', response.access_token);
        this.setInactivityTimer();
        this.storageMonitorService.startMonitoring();
        this.setRenewalTimer();
      },
      error: () => {
        this.logout();
      }
    });
  }

  private setInactivityTimer() {
    this.clearInactivityTimer();
    this.inactivityTimer = setTimeout(() => {
      this.checkActivity();
    }, 120000); // 2 minutos
  }

  private clearInactivityTimer() {
    if (this.inactivityTimer) {
      clearTimeout(this.inactivityTimer);
    }
  }

  private setRenewalTimer() {
    this.tokenExpirationTimer = setInterval(() => {
      if (localStorage.getItem('mlct')) {
        this.renewToken();
      } else {
        this.logout();
      }
    }, 60000); // 1 minuto
  }

  private clearRenewalTimer() {
    if (this.tokenExpirationTimer) {
      clearInterval(this.tokenExpirationTimer);
    }
  }

  private clearInterval() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
  }

  logout() {
    this.clearInactivityTimer();
    this.clearInterval();
    this.clearRenewalTimer();
    this.storageMonitorService.stopMonitoring();
    if (!localStorage.getItem('mlct')) {
      window.location.href = '/login';
    }
    localStorage.clear();
    this.logoutService.logout();
    window.location.href = '/login';
  }

  renewToken() {
    const url = `${this.urlApiManagement}/api/v1/token/refresh`;
    const body = {
      token: localStorage.getItem('mlct'),
      userEmail: this.userEmail
    };
    this.http.post(url, body).subscribe({
      next: (response: any) => {
        localStorage.setItem('mlct', response.access_token);
        this.setInactivityTimer();
      },
      error: () => {
        this.logout();
      }
    });
  }

  startMonitoring() {
    this.checkInterval = setInterval(() => {
      this.checkActivity();
    }, 1000);
  }

  private checkActivity() {
    const lastActivity = parseInt(localStorage.getItem('lastActivity') || '0', 10);
    const currentTime = new Date().getTime();
    if (lastActivity === 0 || currentTime - lastActivity > 3600000) {
      this.logout();
    } else {
      this.setInactivityTimer();
    }
  }
}
